"use client";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
const COMPONENT_NAME = "CustomerTelemetryClient";
const LOGROCKET_CONFIG = {
  console: {
    isEnabled: true
  }
};
function initializeLogRocket(pageName) {
  if (process.env.NEXT_PUBLIC_LOGROCKET_CUSTOMERRECORDING_APPID && typeof window !== "undefined") {
    try {
      LogRocket.init(
        process.env.NEXT_PUBLIC_LOGROCKET_CUSTOMERRECORDING_APPID,
        LOGROCKET_CONFIG
      );
      LogRocket.track(`BMod${pageName}`);
      LogRocket.log(`BMod ${pageName} triggered`);
    } catch (e) {
      console.error(`LogRocket initialization failed: ${e}`);
    }
    try {
      setupLogRocketReact(LogRocket);
    } catch (e) {
      console.error(`Unable to setup logrocket-react plugin: ${e}`);
    }
    try {
      if ((localStorage == null ? void 0 : localStorage.getItem("debugLogRocket")) === "true") {
        window.LogRocket = LogRocket;
      }
    } catch (e) {
      console.error(`localStorage not defined`);
    }
  }
}
const CustomerTelemetryClient = ({
  isTranscendCookieMonitoringEnabled,
  pageName
}) => {
  var _a;
  if (isTranscendCookieMonitoringEnabled) {
    if (typeof window !== "undefined" && ((_a = window.airgap) == null ? void 0 : _a.isConsented(/* @__PURE__ */ new Set(["SaleOfInfo"])))) {
      initializeLogRocket(pageName);
    }
  } else {
    initializeLogRocket(pageName);
  }
  return null;
};
CustomerTelemetryClient.displayName = COMPONENT_NAME;
export {
  CustomerTelemetryClient
};
